import type { ActivationAlertsContractSocialAdPlatform } from "@similarweb/pro-api-client";

export type SocialSubcategoryId = ActivationAlertsContractSocialAdPlatform;

// Brand names — intentionally not translated
const SOCIAL_PLATFORM_NAMES: Record<SocialSubcategoryId, string> = {
    Facebook: "Facebook",
    AudienceNetwork: "Facebook Audience Network",
    Messenger: "Facebook Messenger",
    Instagram: "Instagram",
    Threads: "Threads",
    WhatsApp: "WhatsApp",
    LinkedIn: "LinkedIn",
};

export const ALL_SOCIAL_SUBCATEGORIES = Object.keys(SOCIAL_PLATFORM_NAMES) as SocialSubcategoryId[];

export const getPlatformName = (platform: SocialSubcategoryId): string => SOCIAL_PLATFORM_NAMES[platform];
